
import React, { useState, useEffect } from 'react';
import {inputStyles, pageHeaderSubStyles, pageHeaderTitleStyles, pageHeaderStyles, sectionStyles, containerStyles, primaryButtonStyles, formDisclaimerStyles, textareaStyles, labelStyles, formGroupStyles, formRowStyles, sectionTitleStyles} from './styles';

const contactGridStyles = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem' };
const contactInfoStyles = {};
const contactSectionTitleStyles = { fontSize: '1.8rem', fontWeight: '700', marginBottom: '2rem', color: '#333' };
const contactItemStyles = { display: 'flex', gap: '1rem', marginBottom: '2rem', alignItems: 'flex-start' };
const contactIconStyles = { fontSize: '1.5rem', minWidth: '30px' };
const contactFormStyles = { backgroundColor: '#f8f9fa', padding: '3rem', borderRadius: '15px' };
const formStyles = {};


const ContactPage = ({showNotification}) => {

    const API_BASE = '/api';

    const submitContact = async (contactData) => {
    try {
        const response = await fetch(`${API_BASE}/contact`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(contactData),
        });
        
        if (response.ok) {
            showNotification('Thank you for your message! We will get back to you within 24 hours.', 'success');
            return true;
        } else {
            const error = await response.json();
            showNotification(error.detail || 'Error sending message', 'error');
            return false;
        }
        } catch (error) {
        console.error('Error submitting contact form:', error);
        showNotification('Network error. Please check your connection and try again.', 'error');
        return false;
        }
    };

    const [contactForm, setContactForm] = useState({
      first_name: '',
      last_name: '',
      email: '',
      company: '',
      subject: '',
      message: ''
    });

    const handleContactSubmit = async (e) => {
      e.preventDefault();
      const success = await submitContact(contactForm);
      if (success) {
        setContactForm({
          first_name: '',
          last_name: '',
          email: '',
          company: '',
          subject: '',
          message: ''
        });
      }
    };

    return (
      <div>
        <section style={pageHeaderStyles}>
          <div style={containerStyles}>
            <h1 style={pageHeaderTitleStyles}>Get In Touch</h1>
            <p style={pageHeaderSubStyles}>
              Ready to join our community or have questions? We'd love to hear from you
            </p>
          </div>
        </section>

        <section style={sectionStyles}>
          <div style={containerStyles}>
            <div style={contactGridStyles}>
              <div style={contactInfoStyles}>
                <h3 style={contactSectionTitleStyles}>Contact Information</h3>
                
                {/* <div style={contactItemStyles}>
                  <div style={contactIconStyles}>📍</div>
                  <div>
                    <h4>London Office</h4>
                    <p>123 Business Centre<br/>Canary Wharf, London E14 5AB<br/>United Kingdom</p>
                  </div>
                </div> */}

                <div style={contactItemStyles}>
                  {/* <div style={contactIconStyles}>📧</div> */}
                  <div>
                    <h4> 📧 Email</h4>
                    <p>info@saudibritishnetwork.com<br/>membership@saudibritishnetwork.com</p>
                  </div>
                </div>

                {/* <div style={contactItemStyles}>
                  <div style={contactIconStyles}>📞</div>
                  <div>
                    <h4>Phone</h4>
                    <p>+44 20 7123 4567<br/>+44 20 7123 4568 (Events)</p>
                  </div>
                </div> */}

                <div style={contactItemStyles}>
                  {/* <div style={contactIconStyles}>🕒</div> */}
                  <div>
                    <h4>🕒 Office Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM GMT<br/>Saturday: 10:00 AM - 2:00 PM GMT</p>
                  </div>
                </div>
              </div>

              <div style={contactFormStyles}>
                <h3 style={contactSectionTitleStyles}>Send Us a Message</h3>
                <form onSubmit={handleContactSubmit} style={formStyles}>
                  <div style={formRowStyles}>
                    <div style={formGroupStyles}>
                      <label style={labelStyles}>First Name *</label>
                      <input 
                        type="text" 
                        style={inputStyles} 
                        value={contactForm.first_name}
                        onChange={(e) => setContactForm({...contactForm, first_name: e.target.value})}
                        required 
                      />
                    </div>
                    <div style={formGroupStyles}>
                      <label style={labelStyles}>Last Name *</label>
                      <input 
                        type="text" 
                        style={inputStyles} 
                        value={contactForm.last_name}
                        onChange={(e) => setContactForm({...contactForm, last_name: e.target.value})}
                        required 
                      />
                    </div>
                  </div>
                  
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Email Address *</label>
                    <input 
                      type="email" 
                      style={inputStyles} 
                      value={contactForm.email}
                      onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                      required 
                    />
                  </div>
                  
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Company/Organization</label>
                    <input 
                      type="text" 
                      style={inputStyles} 
                      value={contactForm.company}
                      onChange={(e) => setContactForm({...contactForm, company: e.target.value})}
                    />
                  </div>
                  
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Subject *</label>
                   <select 
                      style={inputStyles} 
                      value={contactForm.subject}
                      onChange={(e) => setContactForm({...contactForm, subject: e.target.value})}
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="membership">Membership Inquiry</option>
                      <option value="events">Event Information</option>
                      <option value="">Select a subject</option>
                      <option value="membership">Membership Inquiry</option>
                      <option value="events">Event Information</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="sponsorship">Sponsorship Inquiry</option>
                      <option value="media">Media & Press</option>
                      <option value="general">General Question</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <div style={formGroupStyles}>
                    <label style={labelStyles}>Message *</label>
                    <textarea 
                      style={textareaStyles} 
                      rows="5" 
                      value={contactForm.message}
                      onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                      required
                      placeholder="Please provide details about your inquiry..."
                    />
                  </div>
                  
                  <button type="submit" style={primaryButtonStyles}>Send Message</button>
                  <p style={formDisclaimerStyles}>
                    We typically respond to inquiries within 2 business hours during office hours.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  export default ContactPage;